import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_COLLATERAL_STANDARD_CHARGE_TERMS_Mapper extends BaseFormMapper<BMO_COLLATERAL_STANDARD_CHARGE_TERMS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_COLLATERAL_STANDARD_CHARGE_TERMS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_COLLATERAL_STANDARD_CHARGE_TERMS);

		return _formData;
	}

	MapValues(): Partial<BMO_COLLATERAL_STANDARD_CHARGE_TERMS> {
		return {};
	}
}

const Mappings: BMO_COLLATERAL_STANDARD_CHARGE_TERMS = {};

export interface BMO_COLLATERAL_STANDARD_CHARGE_TERMS {}
